export const FETCH_PUBLIC_TOKEN = 'PUBLIC_TOKEN/FETCH_REQUEST';
export const FETCH_PUBLIC_TOKEN_SUCCESS = 'PUBLIC_TOKEN/FETCH_SUCCESS';

export const CREATE_PUBLIC_TOKEN = 'PUBLIC_TOKEN/CREATE_REQUEST';
export const CREATE_PUBLIC_TOKEN_SUCCESS = 'PUBLIC_TOKEN/CREATE_SUCCESS';

export const DELETE_PUBLIC_TOKEN = 'PUBLIC_TOKEN/DELETE_REQUEST';
export const DELETE_PUBLIC_TOKEN_SUCCESS = 'PUBLIC_TOKEN/DELETE_SUCCESS';
export const DELETE_PUBLIC_TOKEN_FAILURE = 'PUBLIC_TOKEN/DELETE_FAILURE';

export const UPDATE_PUBLIC_TOKEN_STATUS = 'PUBLIC_TOKEN/UPDATE_STATUS_REQUEST';
export const UPDATE_PUBLIC_TOKEN_STATUS_SUCCESS = 'PUBLIC_TOKEN/UPDATE_STATUS_SUCCESS';
export const UPDATE_PUBLIC_TOKEN_STATUS_FAILURE = 'PUBLIC_TOKEN/UPDATE_STATUS_FAILURE';
